// Assets Filters
import digitalAssetsFilters from "components/jiffy/digital-assets/digital-assets-filters/digital-assets-filters";
import digitalAssetsShowMoreFilters from "components/jiffy/digital-assets/digital-assets-filters/digital-assets-show-more-filters";
import digitalAssetsFiltersToggle from "components/jiffy/digital-assets/digital-assets-filters-toggle/digital-assets-filters-toggle";
import digitalAssetsFiltersModal from "components/jiffy/digital-assets/digital-assets-filters-modal/digital-assets-filters-modal";

// PLP
import digitalAssetsPlp from "components/jiffy/digital-assets/digital-assets-plp-wrapper/digital-assets-plp-wrapper";
import digitalAssetsFormSearch from "components/jiffy/digital-assets/digital-assets-form-search/digital-assets-form-search";
import digitalAssetsSelectedFilters from "components/jiffy/digital-assets/digital-assets-selected-filters/digital-assets-selected-filters";
import "components/jiffy/digital-assets/digital-assets-list-layout/digital-assets-list-layout";
import digitalAssetsListPagination from "components/jiffy/digital-assets/digital-assets-list-pagination/digital-assets-list-pagination";
import "components/jiffy/digital-assets/digital-assets-header-banner/digital-assets-header-banner";
import digitalAssetsSectionList from "components/jiffy/digital-assets/digital-assets-sections-list/digital-assets-sections-list";
import "components/jiffy/digital-assets/digital-assets-similar-item-wrapper/digital-assets-similar-item-wrapper";
import "components/jiffy/digital-assets/digital-assets-search-wrapper/digital-assets-search-wrapper";
import "components/jiffy/digital-assets/digital-assets-logo/digital-assets-logo";
import digitalAssetSortForm from "components/jiffy/digital-assets/digital-assets-sort-form/digital-assets-sort-form";
import "components/jiffy/digital-assets/digital-assets-zero-result/digital-assets-zero-result";

// Common
import initDigitalAssetsCard from "./digital-assets/digital-assets-asset-card";
import initDigitalAssetsAddToCart from "./digital-assets/digital-assets-add-to-cart";
import initDigitalAssetsMyLibrary from "./digital-assets/digital-assets-my-library";
import "./digital-assets/digital-assets-common";

const initDigitalAssetsFilters = () => {
  const plpFiltersModal = digitalAssetsFiltersModal();
  digitalAssetsFiltersToggle({
    eventCallback: () => plpFiltersModal.toggleModal()
  });
  plpFiltersModal.loadFacets();
  digitalAssetsFilters();
  digitalAssetsSelectedFilters();
  digitalAssetsShowMoreFilters();
};

const initDigitalAssetsPlp = () => {
  digitalAssetsPlp();
  digitalAssetsSectionList();
  digitalAssetsListPagination();
  digitalAssetsFormSearch();
  digitalAssetSortForm();
};

document.addEventListener("DOMContentLoaded", () => {
  initDigitalAssetsPlp();
  initDigitalAssetsFilters();
  initDigitalAssetsCard();
  initDigitalAssetsAddToCart();
  initDigitalAssetsMyLibrary();
});
